import * as Utilities from "../forum/utilities";
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".list-group-item-menu, .message").forEach((element) => {
        const isMessageContext = element.classList.contains("message");
        const contextMenu = element.querySelector(".context-menu");
        if (contextMenu) {
            let messageId = 0;
            const quoteableElement = element.querySelector(".selectionQuoteable");
            if (quoteableElement != null) {
                messageId = parseInt(quoteableElement.id, 10);
            }
            if (window.matchMedia("only screen and (max-width: 760px)").matches) {
                const el = element;
                // listen for the long-press event
                el.addEventListener("long-press", (e) => {
                    e.preventDefault();
                    if (isMessageContext && contextMenu) {
                        const selectedText = getSelectedMessageText();
                        if (selectedText.length) {
                            const searchItem = contextMenu.querySelector(".item-search");
                            const selectedItem = contextMenu.querySelector(".item-selected-quoting");
                            const selectedDivider = contextMenu.querySelector(".selected-divider");
                            searchItem === null || searchItem === void 0 ? void 0 : searchItem.remove();
                            selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.remove();
                            selectedDivider === null || selectedDivider === void 0 ? void 0 : selectedDivider.remove();
                            if (contextMenu.dataset.url) {
                                const link = document.createElement("a");
                                link.classList.add("dropdown-item", "item-selected-quoting");
                                link.href = `javascript:goToURL('${messageId}','${selectedText}','${contextMenu.dataset.url} ')`;
                                link.innerHTML = `<i class="fas fa-quote-left"></i>&nbsp;${contextMenu.dataset.quote}`;
                                contextMenu.appendChild(link);
                            }
                            const linkSearch = document.createElement("a");
                            linkSearch.classList.add("dropdown-item", "item-search");
                            linkSearch.href = `javascript:copyToClipBoard('${selectedText}')`;
                            linkSearch.innerHTML = `<i class="fas fa-clipboard"></i>&nbsp;${contextMenu.dataset.copy}`;
                            contextMenu.appendChild(linkSearch);
                            const divider = document.createElement("div");
                            divider.classList.add("dropdown-divider", "selected-divider");
                            const linkSelected = document.createElement("a");
                            linkSelected.classList.add("dropdown-item", "item-search");
                            linkSelected.href = `javascript:searchText('${selectedText}')`;
                            linkSelected.innerHTML = `<i class="fas fa-search"></i>&nbsp;${contextMenu.dataset.search} "${selectedText}"`;
                            contextMenu.appendChild(linkSelected);
                        }
                    }
                    contextMenu.style.left = `${e.detail.pageX}px`;
                    contextMenu.style.top = `${e.detail.pageY}px`;
                    contextMenu.style.display = "block";
                    contextMenu.classList.add("show");
                });
            }
            element.addEventListener("contextmenu", (e) => {
                e.preventDefault();
                // close other
                document.querySelectorAll(".context-menu").forEach((menu) => {
                    menu.style.display = "none";
                    menu.classList.remove("show");
                });
                if (isMessageContext) {
                    const selectedText = getSelectedMessageText();
                    if (selectedText.length) {
                        const searchItem = contextMenu.querySelector(".item-search"), selectedItem = contextMenu.querySelector(".item-selected-quoting"), selectedDivider = contextMenu.querySelector(".selected-divider");
                        if (searchItem != null) {
                            document.querySelectorAll(".item-search").forEach((item) => {
                                item.remove();
                            });
                        }
                        if (selectedItem != null) {
                            selectedItem.remove();
                        }
                        if (selectedDivider != null) {
                            selectedDivider.remove();
                        }
                        if (contextMenu.dataset.url) {
                            const link = document.createElement("a");
                            link.classList.add("dropdown-item", "item-selected-quoting");
                            link.href = `javascript:goToURL('${messageId}','${selectedText}','${contextMenu.dataset.url} ')`;
                            link.innerHTML = `<i class="fas fa-quote-left"></i>&nbsp;${contextMenu.dataset.quote}`;
                            contextMenu.appendChild(link);
                        }
                        const linkSearch = document.createElement("a");
                        linkSearch.classList.add("dropdown-item", "item-search");
                        linkSearch.href = `javascript:copyToClipBoard('${selectedText}')`;
                        linkSearch.innerHTML = `<i class="fas fa-clipboard"></i>&nbsp;${contextMenu.dataset.copy}`;
                        contextMenu.appendChild(linkSearch);
                        const divider = document.createElement("div");
                        divider.classList.add("dropdown-divider", "selected-divider");
                        const linkSelected = document.createElement("a");
                        linkSelected.classList.add("dropdown-item", "item-search");
                        linkSelected.href = `javascript:searchText('${selectedText}')`;
                        linkSelected.innerHTML = `<i class="fas fa-search"></i>&nbsp;${contextMenu.dataset.search} "${selectedText}"`;
                        contextMenu.appendChild(linkSelected);
                    }
                }
                contextMenu.style.display = "block";
                contextMenu.style.left = e.offsetX + "px";
                contextMenu.style.top = e.offsetY + "px";
                contextMenu.classList.add("show");
                return false;
            });
            element.addEventListener("click", () => {
                contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.classList.remove("show");
                contextMenu.style.display = "none";
            });
            contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.addEventListener("click", (event) => {
                const targetElement = event.target;
                if (targetElement.parentElement && targetElement.parentElement.matches('[data-bs-toggle="confirm"]')) {
                    event.preventDefault();
                    var button = event.target.parentElement;
                    const text = button.dataset.title;
                    const yes = button.dataset.yes;
                    const no = button.dataset.no;
                    const title = button.innerHTML;
                    Utilities.bootboxConfirm(button, title, text, yes, no, (r) => {
                        if (r) {
                            button.click();
                        }
                        else {
                            contextMenu.classList.remove("show");
                            contextMenu.style.display = "none";
                        }
                    });
                    contextMenu.classList.remove("show");
                    contextMenu.style.display = "none";
                }
            }, false);
            document.querySelector("body").addEventListener("click", () => {
                if (contextMenu) {
                    contextMenu.classList.remove("show");
                    contextMenu.style.display = "none";
                }
            });
        }
    });
});
export function goToURL(messageId, input, url) {
    window.location.href = `${url}&q=${messageId}&text=${encodeURIComponent(input)}`;
}
export function searchText(input) {
    const a = document.createElement("a");
    a.target = "_blank";
    a.href = `https://www.google.com/search?q=${encodeURIComponent(input)}`;
    a.click();
}
function getSelectedMessageText() {
    var _a, _b;
    let text = "";
    const sel = window.getSelection();
    if (sel === null || sel === void 0 ? void 0 : sel.rangeCount) {
        const container = document.createElement("div");
        for (let i = 0; i < sel.rangeCount; ++i) {
            container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        text = (_b = (_a = container.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : "";
    }
    return text
        .replace(/<p[^>]*>/gi, "\n")
        .replace(/<\/p>| {2}/gi, "")
        .replace(/["';()]/g, "");
}
const _global = (window /* browser */ || global) /* node */;
_global.goToURL = goToURL;
_global.searchText = searchText;
